//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/LineDesigner.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[["displayPart"],"ValidatePlantStructure",{},1,0],[["displayPart"],"ValidateComponentPosition",{},1,0],[["compsToValidateTag"],"ValidateRigidGroups",{},1,0],[["compsToValidateTag"],"ValidateJointData",{},1,0],[["compsToValidateTag"],"ValidatePoseData",{},1,0],[["compsToValidate"],"ValidateJointJogData",{},1,0],[["displayPart"],"ValidateEndItemStructure",{},1,0],[["displayPart"],"ValidateRefSetStructure",{},1,0],[["compsToValidateTag"],"ValidateConnections",{},1,0]],[]];
SPLM.LineDesigner.LineDesignerDebugSession = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.LineDesigner.LineDesignerDebugSession";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;